import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all planningHorizons
export const getPlanningHorizon = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/planning-horizon`);
    return response.data;
  } catch (error) {
    console.error("Error fetching planning-horizons:", error.response?.data || error);
    throw error;
  }
};

// GET a single planningHorizon
export const getPlanningHorizonById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/planning-horizon/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching planning-horizons:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new planningHorizon
export const createPlanningHorizon = async (planningHorizonData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/planning-horizon`, planningHorizonData);
    return response.data;
  } catch (error) {
    console.error("Error creating planning-horizons:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing planningHorizon
export const updatePlanningHorizon = async (id, planningHorizonData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/planning-horizon/${id}`, planningHorizonData);
    return response.data;
  } catch (error) {
    console.error("Error updating planning-horizons:", error.response?.data || error);
    throw error;
  }
};

// DELETE a planningHorizon
export const deletePlanningHorizon = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/planning-horizon/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting planning-horizons", error.response?.data || error);
    throw error;
  }
};
